import React from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as EmptyList } from '../../assets/icons/GraphicsEmpty.svg'

const EmptyState = ({ label }) => {
  return (
    <section className="empty-state">
      <EmptyList className="empty-state__graphic"/>
      <p className="empty-state__label">{label}</p>
    </section>
  )
}

EmptyState.propTypes = {
  label: PropTypes.string,
}

export default EmptyState
